// import Layout from '@/layout/index.vue'
import { businessRoute } from '@/router/modules/business'
export const staticRoute: any = [
  ...businessRoute
]

// 一级菜单（顺序：协会管理 → 探店管理；id 与各菜单 tabId、generator-router 中协会 Tab 一致，勿随意改）
export const tabDtoList = [
  { id: 2, tabCode: 'business123', tabName: '协会管理' },
  { id: 1, tabCode: 'business', tabName: '探店管理' }
]
export const menuList = [
  {
    id: 158,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'store_manager',
    path: '/store',
    redirect: '',
    meta: {
      title: '门店管理',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 251,
    tabId: 2,
    pid: 158,
    component: 'business/store/main',
    hidden: false,
    name: 'store_list',
    path: 'business/store/main',
    redirect: '',
    meta: {
      title: '门店列表',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 255,
    tabId: 2,
    pid: 158,
    component: 'business/enterprise/index',
    hidden: false,
    name: 'store_enterprise',
    path: 'business/enterprise/index',
    redirect: '',
    meta: {
      title: '标签管理',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 260,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'association_config',
    path: '/associationConfig',
    redirect: '',
    meta: {
      title: '协会配置',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 261,
    tabId: 2,
    pid: 260,
    component: 'association/config/index',
    hidden: false,
    name: 'association_config_list',
    path: 'association/config/index',
    redirect: '',
    meta: {
      title: '协会配置',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 271,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'association_staff',
    path: '/associationStaff',
    redirect: '',
    meta: {
      title: '协会成员',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 272,
    tabId: 2,
    pid: 271,
    component: 'association/staff/index',
    hidden: false,
    name: 'association_staff_list',
    path: 'association/staff/index',
    redirect: '',
    meta: {
      title: '协会成员',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 276,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'association_meeting',
    path: '/associationMeeting',
    redirect: '',
    meta: {
      title: '协会会议',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 277,
    tabId: 2,
    pid: 276,
    component: 'association/meeting/index',
    hidden: false,
    name: 'association_meeting_list',
    path: 'association/meeting/index',
    redirect: '',
    meta: {
      title: '协会会议',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 262,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'post_manage',
    path: '/postManage',
    redirect: '',
    meta: {
      title: '推文管理',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 263,
    tabId: 2,
    pid: 262,
    component: 'business/postManage/index',
    hidden: false,
    name: 'post_manage_list',
    path: 'business/postManage/index',
    redirect: '',
    meta: {
      title: '推文管理',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 264,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'member_manage',
    path: '/memberManage',
    redirect: '',
    meta: {
      title: '会员管理',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 265,
    tabId: 2,
    pid: 264,
    component: 'business/memberManage/index',
    hidden: false,
    name: 'member_formal_list',
    path: 'business/formalMember/index',
    redirect: '',
    meta: {
      title: '正式会员',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 275,
    tabId: 2,
    pid: 264,
    component: 'association/memberApplication/index',
    hidden: false,
    name: 'member_application_list',
    path: 'association/memberApplication/index',
    redirect: '',
    meta: {
      title: '会员申请记录',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 268,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'safety_officer_mgmt',
    path: '/safetyOfficer',
    redirect: '',
    meta: {
      title: '食安员管理',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 267,
    tabId: 2,
    pid: 268,
    component: 'association/companyManage/index',
    hidden: false,
    name: 'company_manage_list',
    path: 'association/companyManage/index',
    redirect: '',
    meta: {
      title: '公司管理',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 269,
    tabId: 2,
    pid: 268,
    component: 'association/safetyOfficer/index',
    hidden: false,
    name: 'safety_officer_list',
    path: 'association/safetyOfficer/index',
    redirect: '',
    meta: {
      title: '食安员列表',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 270,
    tabId: 2,
    pid: 268,
    component: 'association/exam/index',
    hidden: false,
    name: 'exam_manage_list',
    path: 'association/exam/index',
    redirect: '',
    meta: {
      title: '考试管理',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 278,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'association_advise',
    path: '/associationAdvise',
    redirect: '',
    meta: {
      title: '用户反馈',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 279,
    tabId: 2,
    pid: 278,
    component: 'association/advise/index',
    hidden: false,
    name: 'association_advise_list',
    path: 'association/advise/index',
    redirect: '',
    meta: {
      title: '用户反馈',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  }
]
